import { CommonUtility } from '@utility/common';
import { APIPath } from '@utility/constants/api';
import { BaseService } from './base';
import { CRUDService } from './crud';

class CRM extends CRUDService {
  constructor() {
    super(APIPath.crm);
  }

  crmFile = () => BaseService.get(`${APIPath.crmSpreadSheet}`);

  crmOrders = customerId =>
    BaseService.get(`${APIPath.crmOrders}/${customerId}`);

  deleteCustomers = customerIds =>
    BaseService.remove(`${APIPath.crm}/${customerIds}`);

  searchCustomers = params => {
    const query = CommonUtility.objectToParams(params);
    return BaseService.get(`${APIPath.customersSearch}?${query}`);
  };
}

const CRMService = new CRM();
Object.freeze(CRMService);
export default CRMService;
